import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const ClockIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00163 15.1667C11.6835 15.1667 14.6683 12.1819 14.6683 8.50004C14.6683 4.81814 11.6835 1.83337 8.00163 1.83337C4.31973 1.83337 1.33496 4.81814 1.33496 8.50004C1.33496 12.1819 4.31973 15.1667 8.00163 15.1667Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M8.00195 5.83337V8.50004L9.33529 9.83337"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
